import { IUserPhoto } from '../Stores/UserPhotoStore';
import { ApiService } from '../_services/ApiService';

export enum TagType {
    DATE = 3,
    LOCATION = 4,
    FILENAME = 5
}

export interface IPhotoForServer {
    image: any;
    rotateDegrees: number;
    tags: Partial<Record<keyof typeof TagType, string>>;
    image_thumbnail?: any;
}

export class PhotoService extends ApiService {
    protected basePath = 'photos';
    protected subPaths = {
        forPhoto: (id: number) => `${id}`,
        notify: `notify`
    };

    public getAllPhotosForCurrentUser(): Promise<Array<IUserPhoto>> {
        return this.getRequest().then(response => {
            return response;
        });
    }

    public uploadPhoto(data: IPhotoForServer): Promise<IUserPhoto> {
        return this.postRequest(this.formatPhotoFormData(data)).then(response => {
            return response;
        });
    }

    public updatePhoto(data: IUserPhoto, rotatedPhoto?: Blob, rotatedThumbnail?: Blob): Promise<void> {
        let dataForPut: { tags: {}; rotate_degrees: number } | FormData = {
            tags: {
                [TagType.DATE]: data.description.date || '',
                [TagType.LOCATION]: data.description.location || '',
                [TagType.FILENAME]: data.description.filename || '',
            },
            rotate_degrees: data.rotate_degrees
        };

        if (rotatedPhoto) {
            dataForPut = this.formatPhotoFormData({ ...dataForPut, image: rotatedPhoto, image_thumbnail: rotatedThumbnail, tags: JSON.stringify(dataForPut.tags) });
        }

        return this.putSubPath(this.subPaths.forPhoto(data.id), dataForPut);
    }

    public removePhoto(id: number): Promise<void> {
        return this.deleteSubPath(id.toString());
    }

    private formatPhotoFormData(image: any): FormData {
        const formData = new FormData();
        formData.append('image', image.image);
        formData.append('tags', image.tags);
        formData.append('rotate_degrees', image.rotate_degrees || 0);
        formData.append('image_thumbnail', image.image_thumbnail);
        return formData;
    }

    public sendPhotoCountNotification(storyID: number, photoID: number, photoCount: number): void {
        this.postSubPath(this.subPaths.notify, {
            collection_id: storyID,
            photo_id: photoID,
            photos_added_count: photoCount
        });
    }
}



// WEBPACK FOOTER //
// ./src/Services/PhotoService.tsx